import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Alert } from 'src/app/models/alert';
import { ApiDataService } from 'src/app/shared/services/api.data.service';
import { FleethdService } from '../../../services/fleethd.service';

@Injectable({
  providedIn: 'root'
})
export class AlertDetailService {

  constructor(
    private apiDataService: ApiDataService,
    private fleetHdService: FleethdService) {
  }

  getData(id: string): Observable<Alert> {
    const url = `${this.apiDataService.buildUrl('alert')}/${id}`;
    return this.apiDataService.get(url);
  }

  getChildren(id: string): Observable<any[]> {
    const url = `${this.apiDataService.buildUrl('alert')}/${id}/children`;
    return this.apiDataService.get(url);
  }

  getCaseByAlertId(alertId: string): Observable<any> {
    const url = `${this.apiDataService.buildUrl('case')}/alertId/${alertId}`;
    return this.apiDataService.get(url);
  }

  getActiveCase(assetId: string, alertRuleId: string): Observable<any> {
    const url = `${this.apiDataService.buildUrl('case')}/activeForAsset/${assetId}/${alertRuleId}`;
    return this.apiDataService.get(url);
  }

  createCase(request: any): Observable<void> {
    const url = this.apiDataService.buildUrl('case');
    return this.apiDataService.post(url, request);
  }

  updateCase(request: any): Observable<void> {
    const url = this.apiDataService.buildUrl('case');
    return this.apiDataService.put(url, request);
  }

  // POST case/{id}/comments — 202, applied asynchronously.
  addCaseComment(caseId: string, body: string): Observable<void> {
    const url = `${this.apiDataService.buildUrl('case')}/${caseId}/comments`;
    return this.apiDataService.post(url, { body });
  }

  // DELETE case/{id}/comments/{commentId} — 202, applied asynchronously.
  deleteCaseComment(caseId: string, commentId: string): Observable<void> {
    const url = `${this.apiDataService.buildUrl('case')}/${caseId}/comments/${commentId}`;
    return this.apiDataService.delete(url, {});
  }
}